import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { DatasourceLineageSubplaceRouter, DatasourceLineageSubplaceRouterProps } from './DatasourceLineageSubplace';

export type EmbeddableDatasourceSubplaceProps = VizPortalDataCatalogProviderProps & DatasourceLineageSubplaceRouterProps;

export function EmbeddableDatasourceSubplaceWithoutRouter(props: EmbeddableDatasourceSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <DatasourceLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
